import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sremote-support',
  templateUrl: './sremote-support.component.html',
  styleUrls: ['./sremote-support.component.scss']
})
export class SremoteSupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
